const shipping = {
  'admin.shipping.menus.hetmet': 'Shippings List - Shipping Manager',
  'admin.shipping.menus.breadcrumb.heading': 'Shippings List',
  'admin.shipping.menus.breadcrumb.parent': 'Shipping Manager',
  'admin.shipping.btn.add': 'Add new shipping',
  'admin.shipping.noti.create-shipping.success': 'Add new shipping successfully!',
  'admin.shipping.noti.create-shipping.failure': 'Add new shipping unsuccessfully!',
  'admin.shipping.noti.update-shipping.success': 'Update shipping successfully!',
  'admin.shipping.noti.update-shipping.failure': 'Update shipping unsuccessfully!',
  'admin.shipping.noti.delete-shipping.success': 'Delete shipping successfully!',
  'admin.shipping.noti.delete-shipping.failure': 'Delete shipping unsuccessfully!',
  'admin.shipping.column.sort': 'Order',
  'admin.shipping.column.name': 'Name',
  'admin.shipping.column.logo': 'Logo',
  'admin.shipping.column.price': 'Fee',
  'admin.shipping.column.active': 'Active',
  'admin.shipping.modal.delete.title': 'Confirm delete shipping!',
  'admin.shipping.modal.delete.description': 'Are you sure you want to delete this shipping?',
  'admin.shipping.error-msg.name': 'Please enter dealer name!',
  'admin.shipping.error-msg.logo': 'Please select a logo!',
  'admin.shipping.error-msg.price': 'Please enter shipping cost!',
  'admin.shipping.modal.action.title.create': 'Add a new shipping',
  'admin.shipping.modal.action.title.update': 'Update shipping',
  'admin.shipping.modal.action.title.details': 'Detail shipping',
  'admin.shipping.modal.action.btn.create': 'Add new',
  'admin.shipping.modal.action.btn.update': 'Update',
  'admin.shipping.modal.action.label.name': 'Shipping name',
  'admin.shipping.modal.action.label.logo': 'Logo',
  'admin.shipping.modal.action.label.price': 'Fee ship',
  'admin.shipping.modal.action.label.active': 'Active',
};

export default {
  ...shipping,
};
